__turbopack_context__.v({
  "container": "CfHF2G_container",
  "label": "CfHF2G_label",
  "readOnly": "CfHF2G_readOnly",
  "spacer": "CfHF2G_spacer",
  "valid": "CfHF2G_valid",
});
